import { mapState } from 'vuex'
import { layouts } from '@/app/const/settings'

const TIMER = 1000

export default {
  data () {
    return {
      currentPage: 0,
      currentPageInterval: null
    }
  },
  computed: {
    ...mapState({
      size: state => state.board.size,
      tickets: state => state.board.tickets,
      clientsQueue: state => state.board.clientsQueue,
      pageTimer: state => state.gui.settings.colorScheme.pageTimer,
      layout: state => state.gui.settings.layout.code
    }),
    layoutCol2State () {
      return this.layout === layouts.col2State
    },
    layoutCol3Flag () {
      return this.layout === layouts.col3Flag
    },
    layoutCol2DiffClients () {
      return this.layout === layouts.col2DiffClients
    },
    startTicketNumber () {
      return this.currentPage * this.size
    },
    endTicketNumber () {
      return (this.currentPage + 1) * this.size
    },
    maxCountPage () {
      return Math.ceil(this.tickets.length / this.size)
    },
    currentTickets () {
      if (this.layoutCol2State || this.layoutCol3Flag) {
        return this.tickets
      }
      if (this.layoutCol2DiffClients) {
        return this.clientsQueue
      }

      return this.tickets.slice(this.startTicketNumber, this.endTicketNumber)
    },
    paginatorOn () {
      return this.pageTimer > 0 && !this.layoutCol2State && !this.layoutCol3Flag
    },
    showPaginatorHelper () {
      return this.paginatorOn && this.maxCountPage > 1
    }
  },
  methods: {
    startPagePaginator () {
      if (this.paginatorOn) {
        clearInterval(this.currentPageInterval)
        this.currentPage = 0
        this.currentPageInterval = setInterval(() => {
          if (this.currentPage < this.maxCountPage - 1) {
            this.currentPage++
          } else {
            this.currentPage = 0
          }
        }, this.pageTimer * TIMER)
      }
    },
    isActive (item) {
      return item - 1 === this.currentPage
    }
  }
}
